import React from "react";
import { makeStyles} from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import { Link } from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Indicators from "../Reviews/Indicators";
import PointIndicators from "../Points/PointIndicators";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
  },
  link: {
    textDecoration: "None",
  },
  action: {
    backgroundColor: theme.palette.background.paper,
    overflow:"hidden",
    width: 250,
    height: 120,
    borderRadius: 5,
    border:"1px solid lightgray",
    color: "black",
    fontWeight: "bold",
    textTransform: "none",
    padding: 12,
    margin: 12,
    "&:hover": {
      boxShadow: "0px 0px 9px 0px rgba(50, 50, 50, 0.75)",
    },
  },
  icon: {
    position: "relative",
    color: "orange",
    opacity: 0.2,
    top: 0,
    marginLeft: 150,
    fontSize: 150,
    zIndex: 2,
  },
}));

const Landing = () => {
  const classes = useStyles();
  // const { state } = useContext(ItemsContext);

  return (
    <Fade in>
      <div className={classes.root}>
        <Indicators/>
        <PointIndicators/>
        <Link className={classes.link} to="/products">
          <div className={classes.action}>
            <h2 style={{ position: "absolute" }}>Crear Producto</h2>
            <AddCircleOutlineIcon className={classes.icon} />
          </div>
        </Link>
      </div>
    </Fade>
  );
};
export default Landing;
